module.exports = __webpack_public_path__ + "static/img/giphy_cherryblitz.48afe3f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/giphy_cherryblitz.gif
// module id = v99a
// module chunks = 0